export default "__VITE_ASSET__Cb79aX8v__"